import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, Box, Typography, Divider } from '@material-ui/core';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';

const useStyles = makeStyles(theme => ({
  card: {
  	height: 350
  }
}));

export default props => { 
	const { pos, accuracy, address } = props.location;
	const classes = useStyles(props);
	const latLon = [ pos.lat, pos.lon ];

	return (
		<MapContainer center={latLon} zoom={11} scrollWheelZoom={false} className={classes.card}>
		  <TileLayer
		    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
		    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
		  />
			{isNaN(accuracy) ? null : (
				<Circle
					center={latLon} 
					pathOptions={{ color: '#3f51b5', weight: 1 }} 
					radius={accuracy} 
				/>
			)}
		  <Marker position={latLon}>
		    <Popup>
		      <p>Accuracy: {accuracy}m</p>
		      {address}
		    </Popup>
		  </Marker>
		</MapContainer>
	)
};